import React from 'react';
import { Col, Row } from "reactstrap"
import { formatPenalty } from '../../utils'

export const TeamFoulsStatsTable = ({ teamFoulsStats }) => {

    const getTeamFoulsStatsRow = () => {
        return teamFoulsStats.map((team, i) => {
            const rowClassName = i % 2 === 0 ? "row-odd" : "row-even";
            return (
                <Row className={rowClassName} key={team.name}>
                    <Col xs="4" style={{ textAlign: 'left' }}>{team.name}</Col>
                    <Col xs="3">
                        <Row>
                            <Col xs="12" style={{ textAlign: 'right' }}>{team.matches}</Col>
                        </Row>
                        <Row>
                            <Col xs="12" style={{ textAlign: 'right' }}><img src={team.teamLogoLink} width="30px" height="30px" alt={team.name} /></Col>
                        </Row>
                    </Col>
                    <Col xs="2" style={{ textAlign: 'right', alignSelf: 'center' }}>{formatPenalty(team.fouls / team.matches)}</Col>
                    <Col xs="3" style={{ textAlign: 'right', alignSelf: 'center' }}>{formatPenalty(team.fouls)}</Col>
                </Row>
            )
        })
    }

    return (<div className="stats-table-wrapper">
        <Row className="stats-header-row">
            <Col xs="4" style={{ textAlign: 'left' }}>Equipo</Col>
            <Col xs="3" style={{ textAlign: 'right' }}>PJ</Col>
            <Col xs="2" style={{ textAlign: 'right' }}>PIMxP</Col>
            <Col xs="3" style={{ textAlign: 'right' }}>Total (PIM)</Col>
        </Row>
        {getTeamFoulsStatsRow()}
    </div>)
}
